import React, { useMemo } from 'react';
import ReportFilterBar from './components/ReportFilterBar';
import OverviewTab from './components/OverviewTab';
import ByTargetTab from './components/ByTargetTab';
import ByBatchTab from './components/ByBatchTab';
import ByUserTab from './components/ByUserTab';
import { useClassOptions, useFilterOptions } from './hooks/useActivationReport';
import { REPORT_TABS, useReportFilters } from './hooks/useReportFilters';
import { ReportTab } from './types';

const TAB_LABELS: Record<ReportTab, string> = {
  'tong-quan': 'Tổng quan',
  'theo-sach': 'Theo sách',
  'theo-lo': 'Theo lô mã',
  'theo-nguoi-dung': 'Theo người dùng',
};

const ActivationReportPage: React.FC = () => {
  const { tab, setTab, filters, setFilters, clearFilters } = useReportFilters();
  const { data: options } = useFilterOptions();
  const { data: classOptions } = useClassOptions(filters.school_id);

  // Ô Lớp chỉ hiện ở tab người dùng; tab khác không áp class_id (dù còn trên URL)
  // để số liệu khớp bộ lọc đang thấy và file xuất không ghi "Lớp:" ngầm.
  const reportFilters = useMemo(
    () => (tab === 'theo-nguoi-dung' ? filters : { ...filters, class_id: undefined }),
    [tab, filters]
  );

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-gray-900">Báo cáo kích hoạt</h1>

      <ReportFilterBar
        filters={filters}
        options={options}
        classes={classOptions}
        onChange={setFilters}
        onClear={clearFilters}
        showClass={tab === 'theo-nguoi-dung'}
      />

      <div className="flex flex-wrap gap-2 border-b border-gray-200">
        {REPORT_TABS.map((t) => (
          <button
            key={t}
            type="button"
            onClick={() => setTab(t)}
            aria-pressed={tab === t}
            className={`px-4 py-2 text-sm font-medium border-b-2 -mb-px ${
              tab === t
                ? 'border-blue-600 text-blue-700'
                : 'border-transparent text-gray-600 hover:text-gray-900 hover:border-gray-300'
            }`}
          >
            {TAB_LABELS[t]}
          </button>
        ))}
      </div>

      {tab === 'tong-quan' && <OverviewTab filters={reportFilters} onGroupByChange={(g) => setFilters({ group_by: g })} />}
      {tab === 'theo-sach' && <ByTargetTab filters={reportFilters} onChange={setFilters} />}
      {tab === 'theo-lo' && <ByBatchTab filters={reportFilters} onChange={setFilters} />}
      {tab === 'theo-nguoi-dung' && <ByUserTab filters={filters} onChange={setFilters} />}
    </div>
  );
};

export default ActivationReportPage;
